import { getApiOrigin } from "../utils/config";

export const DPD_EXTERNAL_LINK =
  process.env.REACT_APP_EXTERNAL_DOMAIN || "http://localhost:3000";

// Domain constants moved to src/constants/domains.js to avoid import cycles

export const THEME_NAMES = {
  DPD: "dpd",
  DPD_LOCAL: "dpdlocal",
};

export const CHAT_CONFIG = {
  chatBotHost: getApiOrigin(),
  client: process.env.REACT_APP_SF_AUTH_CLIENT_ID,
  chatProxyHost: getApiOrigin(),
  apisBaseUrl: getApiOrigin(),
  businessUnit: 2, // Default business unit clarify how to set it dynamically
  apiVersion: parseInt(process.env.REACT_APP_SF_LIVEAGENT_API_VERSION),
  enhancedChatBaseUrl: process.env.REACT_APP_ENHANCED_CHAT_API_URL,
  isSalesforceCaseRequired: false,
  ssePingMs: process.env.REACT_APP_SSE_PING_MS
    ? parseInt(process.env.REACT_APP_SSE_PING_MS)
    : 30000,
  liveagent: {
    host: process.env.REACT_APP_SF_LIVEAGENT_URL,
    organizationId: process.env.REACT_APP_SF_ORGANIZATION,
    eliteDeploymentId: process.env.REACT_APP_SF_ELITE_DEPLOYMENT_ID,
    platinumDeploymentId: process.env.REACT_APP_SF_PLATINUM_DEPLOYMENT_ID,
    eliteButtonId: process.env.REACT_APP_SF_ELITE_BUTTON_ID,
    platinumButtonId: process.env.REACT_APP_SF_PLATINUM_BUTTON_ID,
    apiVersion: parseInt(process.env.REACT_APP_SF_LIVEAGENT_API_VERSION, 10),
  },
};
